import BaseForm from '@kakadu-dev/base-frontend-helpers/forms/BaseForm';
import { Customer } from "../../../models/Customers";
import { DispatchSelector, StateSelector } from "../../../modules/selectors";
/**
 * Customer push notification target form for type 'device'
 */

export class CustomerPushDeviceTargetForm extends BaseForm {
  constructor(...args) {
    super(...args);
    this.modelClass = Customer;
    this.fields = [{
      label: 'Пользователь',
      name: 'target',
      type: BaseForm.TYPES.AUTOCOMPLETE,
      required: true,
      props: {
        common: {
          dataState: StateSelector.customers.list,
          dataFetch: DispatchSelector.customers.list,
          extraFilter: value => {
            return {
              or: [{
                firstName: `%${value}%`
              }, {
                lastName: `%${value}%`
              }, {
                middleName: `%${value}%`
              }]
            };
          },
          valueColumn: 'id',
          labelColumn: 'name'
        }
      }
    }];
    this.dispatchCreateForm = DispatchSelector.customers.sendPush;
    this.responseCreateState = StateSelector.customers.sendPush;
  }

}